import React, { CSSProperties } from 'react';
import { colors } from '../constants';

type Props = {
  imageUrl?: string;
  size?: number;
  style?: CSSProperties;
  alt?: string;
  // if you need responsive avatars you can use className
  // to override the default width and height
  className?: string;
  fallback?: string;
};

export const Avatar = ({ imageUrl, size = 40, alt = 'User Avatar', style, className, fallback }: Props): JSX.Element => {
  const classes = `rounded-full${className ? ` ${className}` : ''}`;

  const color = [
    colors.sapphire.DEFAULT,
    colors.tangerine.DEFAULT,
    colors.emerald.DEFAULT,
    colors.kiwi.DEFAULT
  ][Math.floor(Math.random() * 6)];

  const hasPhoto = imageUrl && imageUrl.indexOf('us-default-avatar') === -1;

  if (hasPhoto) {
    return (
      <img src={imageUrl} style={style} className={classes} height={size} width={size} alt={alt} />
    );
  }

  if (!hasPhoto && !!fallback) {
    const fallbackStyle = {
      width: size,
      height: size,
      borderColor: color,  // Apply random color to border
      color,        // Apply random color to text
      ...style
    };

    return (
      <div className={`border-2 flex items-center justify-center font-bold text-xl ${classes}`} style={fallbackStyle}>
        {fallback}
      </div>
    );
  }

  if (imageUrl) {
    return (
      <img src={imageUrl} style={style} className={classes} height={size} width={size} alt={alt} />
    );
  }

  return (
    <div className={classes} style={{ height: size, width: size }} />
  );
};
